module.exports = __webpack_public_path__ + "static/media/PP1-Twitter.02ebdb9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Paper1/PP1-Twitter.png
// module id = 247
// module chunks = 0